import { put, takeLeading } from "redux-saga/effects";
import { HttpService } from "src/services";

import { ProgramsConductorAction } from "../actions";
import { ProgramConductorTypes } from "../types";
import { ReduxAction } from "../models";
import { Urls } from "src/constants";
import { AxiosResponse } from "axios";

export function* ProgramsConductorSaga() {
    yield takeLeading(ProgramConductorTypes.REQUEST_LOAD_PROGRAM_CONDUCTOR, requestConductor);
}

function* requestConductor(action: ReduxAction) {

    try {
        const { count, type, offset, getFeatured, clear } = action.payload;
        const api = Urls.program.list(count, type, offset, getFeatured);

        const response: AxiosResponse = yield HttpService.Fetch(api);

        let totalCount = response.headers["x-total-count"];
        totalCount = totalCount === null || totalCount === undefined ? -1 : totalCount;

        const list = response.data?.calendar || [];
        const promotions = response.data?.promotions;

        yield put(ProgramsConductorAction.setData(list, promotions, clear, count, totalCount));

    }
    catch {
        yield put(ProgramsConductorAction.hideLoading());
    }

}